import React from 'react';
import { useNotify, useMutation, Button } from 'react-admin';
import CheckCircle from '@material-ui/icons/CheckCircle';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import RejectIcon from '@material-ui/icons/Warning';
import {WarningButtonStyle} from '../styles/common';
import Tooltip from '@material-ui/core/Tooltip';
import { Box } from "@material-ui/core";
const {AuditStatus} = require('./audit_status');

export const EXCLUDED_BIDDERS_LIST = [502, 507, 207, 714, 707, 902, 807, 907, 607, 713, 303, 702, 802, 307];

export const AdstxtListStatus = ({record, ...props}) => {
  if (!record) return;
  record = record.domain_data || record;
  let positive = 0;
  let total = 0;
  let show = [];
  let adstxtListDetail = [];
  if (record && record.adstxt_results && record.adstxt_results.bidder_results && record.adstxt_results.bidder_results.length>0) {
    record.adstxt_results.bidder_results = record.adstxt_results.bidder_results.filter(x => !EXCLUDED_BIDDERS_LIST.includes(x.bidder_id));
    record.adstxt_results.bidder_results.sort( (x, y) => (x.bidder_name>y.bidder_name) ? 1 : -1 );
    adstxtListDetail.push(<div style={{fontSize: 'larger', fontWeight: 'bold'}}>Adstxt Bidder Details</div>);
    record.adstxt_results.bidder_results.forEach(conf => {
      let auditStatus = '';
      if (record.bidder_audit_status && record.bidder_audit_status['' + conf.bidder_id]) {
        auditStatus = record.bidder_audit_status['' + conf.bidder_id].status;
      }
      if (conf.status===true) {
        let rejected = '';
        let status = '';
        if (auditStatus==='rejected') {
          rejected = ' (rejected)';
          status = <Box mr={{ xs: 0, sm: '5px' }}><CheckCircle style={{width: '12px', color: 'orangered'}}/></Box>;
        } else {
          status = <Box mr={{ xs: 0, sm: '5px' }}><CheckCircle style={{width: '12px', color: 'springgreen'}}/></Box>;
        }
        adstxtListDetail.push(<Box display={{ md: 'block', lg: 'flex' }} fullWidth>
          {status} <Box sx={{marginTop: '5px'}} mr={{ xs: 0, sm: '1em' }}>{conf.bidder_name} {rejected}</Box>
          </Box>
        );
      }
    });
    positive = record.adstxt_results.bidder_results.filter(x => x.status===true).length;
    total = record.adstxt_results.bidder_results.length;
    show.push(<Button label={`${(100*positive/total).toFixed(0)}% `} size="small" variant='contained' 
    disableElevation startIcon={<Tooltip title={adstxtListDetail} arrow leaveDelay="500"><CheckCircle /></Tooltip>} 
    style={{width: '120px', fontSize: '12px', backgroundColor: 'rgba(255, 255, 255, 0.12)', color: 'white', borderRadius: '0%'}}>
    </Button>);
  } else if (record && record.adstxt_results && record.adstxt_results.status===false) {
    show.push(<Button label='Missing' size="small" variant='contained' 
    disableElevation startIcon={<Tooltip title={['Missing:', <br/>, 'Ads.txt File Missing']} arrow leaveDelay="500"><HighlightOffIcon /></Tooltip>} 
    style={{width: '120px', fontSize: '10px', color: 'white', backgroundColor: '#f44336', borderRadius: '0%'}}></Button>);
  }
  return (
    show
  );
};
export function MissingAdstxtButton () {
  return <Button disabled="true" label='Missing Adstxt' size="small" variant='contained' disableElevation
  startIcon={<RejectIcon />} style={WarningButtonStyle}></Button>;
}
export const CrawlButton = (props) => {
  const id =  (props.record && props.record.domain && props.record.domain.code) || (props.record && props.record.code);
  const notify = useNotify();
  const [crawl, { loading }] = useMutation({
      type: 'getOne',
      resource: `domain_crawl?domain=${id}&x=`,
      payload: { }
  },
      {
          onSuccess: ({ data }) => {
              window.location.reload(false)
              notify('We have crawled the Ads.txt file for this Site', 'info', {}, false);
          },
          onFailure: (error) => notify(`Site ads.txt crawl error: ${error.message}`, 'warning'),
      }
  );
  return <Button label="Crawl Ads.txt" onClick={crawl} disabled={loading} startIcon={<PlaylistAddCheckIcon />} variant="contained" color="primary" />;
};
export function BidderStatus(props) {
  if (props.record.status) {
    let match = [];
    if (props.record.match) match = props.record.match.map (x => {
      return <li style={{width: '100%', whiteSpace: 'nowrap'}}>{x}</li>;
    });
    return [<CheckCircle style={{ color: 'springgreen' }} />, ...match];
  }
  return <HighlightOffIcon style={{ color: 'orangered' }} />;
}
export function AdstxtIPWhiteList() {
  return (
    <div style={{paddingTop: '30px', paddingBottom: '10px', width: '100%'}}>
        In case the ads.txt or app-ads.txt file is not crawled, please make sure that the following IP addresses are white listed on the Publisher site:
        <br/>
        <br/>100.24.159.75
        <br/>3.86.173.22
        <br/>18.204.137.42
        <br/>35.163.158.135
        <br/>44.231.143.38
        <br/>44.233.161.248
        <br/>34.246.13.91
        <br/>34.246.5.91
        <br/>34.250.133.243
        <br/>13.235.168.87
        <br/>3.7.120.13
        <br/>35.154.89.31
    </div>
  );
}